import { render, staticRenderFns } from "./transactionSettlement.vue?vue&type=template&id=2a5652d4"
import script from "./transactionSettlement.vue?vue&type=script&lang=js"
export * from "./transactionSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports